import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EventsManager} from "../../events/events.manager";
import {environment} from "../../../environments/environment";
import {GetDocumentDetailRequest} from "../../models/document.request";
import {PlansService} from "../../services/plans.service";
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-summary-discounts',
    templateUrl: './summary-discounts.component.html',
    styleUrl: './summary-discounts.component.scss',
    standalone: true,
    imports: [FormsModule, NgFor, NgIf]
})
export class SummaryDiscountsComponent implements OnInit, AfterViewInit {
  blobUrl: string = environment.blobStorageUrl +'/servicesanddisclosures/';
  feeFileName:string = 'FS_Smile_Generation_';
  discountFileName:string = 'SDF_Smile_Generation_';
  feeUrl:string = '';
  discountUrl:string = '';
  stateChosen:boolean = false;
  currentState:any = {};
  selectedState:string = '';
  stateAbbr:string = '';
  showIfPurchaseIsNotAdha:boolean = false;
  mapImagePath:string = 'assets/images/coverage-map.png';
  constructor(public em: EventsManager,private plansSrvc:PlansService,private route:ActivatedRoute) {

  }

  ngOnInit(): void {

    if(this.em.purchaseIsADHA){
      this.stateAbbr = 'ADHA';

    }

    const url: string = this.route.snapshot.url.join('|');
    console.log(url);
    if(url.includes('adha')) {
      this.stateAbbr = 'ADHA';
      this.showIfPurchaseIsNotAdha = true;
      this.stateChosen = true;
      this.em.purchaseIsADHA = true;
      this.em.setHideHeader(true);
      this.getPlanDocuments();
      this.mapImagePath = 'assets/images/adha-coverage-map.png'
    }

    if(sessionStorage['state'] && !this.showIfPurchaseIsNotAdha){
      this.currentState = JSON.parse(sessionStorage['state']);
      this.selectedState = this.currentState.name;
      this.stateAbbr = this.currentState.abbr;
      this.getPlanDocuments();
    }


  }

  ngAfterViewInit(){
    this.scrollMe();
  }

stateChanged(state:any) {
    if(state.target.value !== 'none'){
      state.target.blur();
      this.stateAbbr = state.target.value;
      this.getPlanDocuments();
    } else {
      this.stateChosen = false;
    }

}

buildUrls(state:string){
    let urls:any = state.split(',');
  this.feeUrl = urls[1];
  this.discountUrl = urls[0];
  this.stateChosen = true;
}

openUrl(url:string){
    if(url == 'fees'){
      window.open(this.feeUrl);
    } else {
      window.open(this.discountUrl);
    }

}

  getPlanDocuments(){
    if(!this.em.purchaseIsADHA){
      let docReq:GetDocumentDetailRequest = {category:'PlanDetails,WebsiteFlyers',brand:'sgdp',year:this.em.planYear,organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:this.stateAbbr};
      this.plansSrvc.getDocumentDetails(docReq).subscribe(
        (response) => {
          this.buildUrls(response);
          this.scrollMe();
        }
      )
    } else {
      const year: string = new Date().getFullYear().toString();
      let docReq:GetDocumentDetailRequest = {category:'PlanDetails,WebsiteFlyers',brand:'sgdp',year:year,organizationId:this.em.orgId,coverageLevelName:'',planName:'',state:this.stateAbbr};
      this.plansSrvc.getDocumentDetails(docReq).subscribe(
        (response) => {
          this.buildUrls(response);
          this.scrollMe();
        }
      )
    }
  }

  scrollMe(){
    window.scrollTo(0,-window.scrollY);
  }
}
